import React from 'react';
import styles from 'styles/layout/TeamsHeaderSection.module.sass';
import SectionHeader from 'components/common/SectionHeader';
import PrimaryButton from 'components/common/PrimaryButton';
import { useNavigate } from 'react-router-dom';
const TeamsHeaderSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className={styles['intro-section']}>
      <SectionHeader subtitle="Meet the Minds Behind the Metrics" />
      <p className={styles['intro-text']}>
        At Zerone Analytiqs, we&apos;re a team of believers, odd defiers and status-quo challengers. We combine technical expertise, managerial excellence, strategic thinking and creativity to deliver on our mission - <strong>empowering decisions</strong>. And we have fun in the process.
      </p>
      <div className={styles['button-wrapper']}>
        <PrimaryButton
          text="Join Our Team"
          primaryColor="#ff5522"
          textColor="#fff"
          hoverColor="#fff"
          hoverTextColor="#ff5522"
          doSomething={() => navigate('/career')}
        />
      </div>
    </section>
  );
};

export default TeamsHeaderSection;
/**
 * TeamsHeaderSection component renders the header section for the "Teams" page.
 * 
 * This section includes:
 * - A title and subtitle introducing the team.
 * - An introductory text about the team's mission and vision.
 * - A button to join the team, linking to the careers page.
 * 
 * @component
 * 
 * @example
 * // Example usage of the TeamsHeaderSection component
 * import TeamsHeaderSection from 'components/layout/team/TeamsHeaderSection';
 * 
 * const App: React.FC = () => (
 *   <TeamsHeaderSection />
 * );
 * 
 * export default App;
 */